// Material UI
import { makeStyles } from '@material-ui/core'
import Colors from '../../../../../../constants/Colors'

const getTotalContainerPaddingTop = (hasDetail: boolean): number =>
  hasDetail ? 2 : 20

export default makeStyles(theme => ({
  detailButtonRoot: {
    justifyContent: 'flex-end',
    padding: '8px 16px',
  },
  detailHeader: {
    alignItems: 'center',
    display: 'grid',
    gridAutoFlow: 'column',
    gridColumnGap: 4,
    justifyContent: 'end',
  },
  detailHeaderIconRoot: {
    height: 18,
    width: 18,
  },
  detailHeaderLabel: {
    color: Colors.SECONDARY_FONT_COLOR,
    letterSpacing: 1,
    textTransform: 'uppercase',
  },
  detailsListContainer: {
    display: 'grid',
    padding: '12px 16px 18px 16px',
    gridRowGap: 10,
    maxHeight: 250,
    overflow: 'auto',
    [theme.breakpoints.up('md')]: {
      maxHeight: 230,
    },
  },
  root: {
    boxShadow: `0 -1px 0 0 ${Colors.DISABLED_COLOR}`,
    color: Colors.PRIMARY_FONT_COLOR,
    lineHeight: 'normal',
  },
  totalContainer: ({ hasDetail }: { hasDetail: boolean }) => ({
    paddingTop: getTotalContainerPaddingTop(hasDetail),
    paddingRight: 16,
    paddingBottom: 20,
    paddingLeft: 16,
  }),
  totalLabel: {},
  totalValue: {},
}))
